import axios from "axios";
import "../../../public/js/config";

const API_URL = window.APP_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
});

export default api;
